
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEcdisProposal as ObiEcdisProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ecdis-proposal.js';
 
 
 

 
 export const ObiEcdisProposal = createComponent({
   react: React,
   tagName: 'obi-ecdis-proposal',
   elementClass: ObiEcdisProposalElement,
   events: {
     
   }
  });
 
 